import React, { Component } from 'react';
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import Button from 'react-toolbox/lib/button';
import { not } from 'ramda';
import { Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import UserDropdown from 'components/AccountDropdown';
import Drawer from 'components/MenuDrawer';
import styles from './Navigation.scss';// to import local scss fle

class NavBar extends Component {

  static isEmpty(val) {
    if (val) {
      return false;
    }
    return true;
  }

  static propTypes = {
    user: PropTypes.shape(),
    profileBanner: PropTypes.bool.isRequired,
    location: PropTypes.shape().isRequired,
  };
  static defaultProps = {
    user: {},
    profileBanner: false,
    logoutUser: () => {},
  };
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
    };
  }

  render() {
    const { user = Map(), location } = this.props;
    const username = user.username;
    const renderLoggedOutLinks = renderIf(NavBar.isEmpty(username));
    const renderLoggedInLinks = renderIf(not(NavBar.isEmpty(username)));
    return (
      <div className={cn('row', styles.navigationContainer)}>
        <div className={cn('col s12', styles.links)}>
          <div className={cn('col s6 m4', styles.logo)}>
            <div className={cn('col s12', styles.logoContainer)}>
              <span>
                <Link to="/" >
                  <img src="https://media.dev.myrecruitboard.com/Images/logo%402x.png" alt="logo" />
                </Link>
              </span>
            </div>
          </div>
          <div className={cn('col s6 m8', styles.navigationLinks)}>
            <div className={cn('col s12', styles.simpleNav)}>
              <span>
                <Link to="/">
                  <button className={location.pathname === '/' ? styles.darkNavigation : ''}>HOME</button>
                </Link>
                <Link to="/about">
                  <button className={location.pathname === '/about' ? styles.darkNavigation : ''}>ABOUT</button>
                </Link>
                <Link to="/sports">
                  <button className={location.pathname === '/sports' ? styles.darkNavigation : ''}>WHY</button>
                </Link>
                <Link to="/terms_and_use">
                  <button className={location.pathname === '/terms_and_use' ? styles.darkNavigation : ''}>TERMS OF USE</button>
                </Link>
                <Link to="/pricing">
                  <button className={location.pathname === '/pricing' ? styles.darkNavigation : ''}>PRICING</button>
                </Link>
                <Link to="/contact">
                  <button className={location.pathname === '/contact' ? styles.darkNavigation : ''}>CONTACT</button>
                </Link>
                {renderLoggedOutLinks(
                      // eslint-disable-next-line
                      <Link to="" className={this.props.profileBanner === true ? styles.hidden : ''}>
                        <Link to="/login">
                          <button>SIGN IN</button>
                        </Link>
                        <Link to="/register">
                          <Button label="JOIN US" className={styles.learnMoreNav} />
                        </Link>
                      </Link>)}
                {renderLoggedInLinks(
                  <a className={styles.dropdownBox}>
                    <UserDropdown {...this.props} />
                  </a>,
                  )}

              </span>
            </div>
            <div className={cn('col s12', styles.menuInSmall)}>
              <div className={cn('col s12', styles.menu)}>
                <span>
                  <Drawer {...this.props} />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default (NavBar);



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js